import { useContext, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Option } from "../../../models/Option";
import { StyleContext } from "../../../providers/StyleContextProvider";
import { DialogInput } from "./DialogInput";
import { MultySelectDialog } from "../dialogs/MultySelectDialog";
import { InputValidation } from "../../../models/InputValidation";
import { MultySelectFilterDialog } from "../dialogs/MultySelectFilterDialog";

interface Props {
    label: string;    
    options: Option[];
    selectedIds?: string;
    setSelected(selectedIds?: string): void;
    searchEnabled?: boolean;
    validation?: InputValidation;
    setValidation?(validation: InputValidation): void;
}

export const MultySelectInput: React.FC<Props> = (props) => {
    const styleContext = useContext(StyleContext);    
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle("input"));
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });    
    const [options, setOptions] = useState<Option[]>(props.options);    
    const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
    const [openDialog, setOpenDialog] = useState<boolean>(false);
                            
    useEffect(() => {        
        setStyles(styleContext.getComponentStyle("input"));          
    }, [isMobile]);

    useEffect(() => {        
        if(props.selectedIds && props.selectedIds !== "") {
            setInitialSelects();
        }          
    }, []);
    
    const setInitialSelects = () => {        
        let selectedIdList: string[] = props.selectedIds!.split(",");
        let selectedOptionList: string[] = [];        
        props.options.forEach(option => {
            if(selectedIdList.includes(option.value.toString())) {                             
                option.checked = true; 
                selectedOptionList.push(option.primaryOption);
            }
        });        
        setSelectedOptions(selectedOptionList);
        setOptions(props.options);
    }
    
    const getSelected = (resultOptions: Option[]) => {  
        let selectedIds: string = "";
        let tempSelectedOptions: string[] = [];           
        resultOptions.forEach((option) => {
            if(option.checked) {
                selectedIds = selectedIds + option.value + ",";
                tempSelectedOptions.push(option.primaryOption);
            }
        });  
        selectedIds = selectedIds.substring(0, selectedIds.length - 1);  
        props.setSelected(selectedIds);
        setSelectedOptions(tempSelectedOptions);        
        setOptions(resultOptions);        
        setOpenDialog(false);     
        if(props.setValidation) {
            props.setValidation({});
        }  
    }    

    const resetOptions = () => {        
        setSelectedOptions([]);
        let tempOptions = [...options];
        tempOptions.forEach(option => {option.checked = false});
        setOptions(tempOptions);
        props.setSelected();
    }

    return (
        <div style={styles}>                
            <div style={styles.inputWrapper} onClick={() => setOpenDialog(true)}>
                <DialogInput values={selectedOptions} validation={props.validation} onReset={resetOptions}>
                    {props.label}
                </DialogInput>
            </div>                      
            {openDialog && (props.searchEnabled ? <MultySelectFilterDialog title={props.label} options={options} getSelected={getSelected} closeDialog={() => setOpenDialog(false)}/>
            : <MultySelectDialog title={props.label} options={options} getSelected={getSelected} closeDialog={() => setOpenDialog(false)}/>)} 
        </div>
    )
}